import { render, staticRenderFns } from "./HelpdeskLayout.vue?vue&type=template&id=61b85e84&scoped=true&"
import script from "./HelpdeskLayout.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskLayout.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskLayout.vue?vue&type=style&index=0&id=61b85e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b85e84",
  null
  
)

export default component.exports